<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行简称')" prop="bankAlias">
                <a-input v-model="queryParam.bankAlias" :maxLength="32" :placeholder="$t('请输入')+$t('银行简称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行名称')" prop="bankName">
                <a-input v-model="queryParam.bankName" :maxLength="32" :placeholder="$t('请输入')+$t('银行名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行编码')" prop="bankCode">
                <a-input v-model="queryParam.bankCode" :maxLength="32" :placeholder="$t('请输入')+$t('银行编码')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('图标')" prop="bankIcon">
                <a-select :placeholder="$t('请选择')+$t('图标')"
                          style="width: 100%" v-model="queryParam.haveBankIcon" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['merchant:bank:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:bank:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
         <span slot="isCommon" slot-scope="text, record">
          <a-switch @change="(checked) => onCommonChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isCommon"/>
        </span>
        <template slot="bankIcon" slot-scope="text, record">
          <div>
            <img v-if="record.bankIcon" :src="record.bankIcon"  style="width:30px;height:30px;" @click="handleRecordPreview(record.bankIcon)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['merchant:bank:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:bank:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {commonBank, listBranch, pageBank} from '@/api/merchant/branch'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {cityListTree, updateHot} from '@/api/logistics';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";

export default {
  name: 'Branch',
  components: {
    TagSelectOption,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      cityList: [],
      citySelected: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        bankCode: undefined,
        cityCode: undefined,
        cityName: undefined,
        haveBankIcon: undefined,
        provinceCode: undefined,
        provinceName: undefined,
        pageNum: 1,
        sortOrder: "asc",
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('银行简称'),
          dataIndex: 'bankAlias',
          align: 'center'
        },
        {
          title: this.$t('银行名称'),
          dataIndex: 'bankName',
          align: 'center'
        },
        {
          title: this.$t('银行编码'),
          dataIndex: 'bankCode',
          align: 'center'
        },
        {
          title: this.$t('银行图标'),
          dataIndex: 'bankIcon',
          scopedSlots: {customRender: 'bankIcon'},
          align: 'center'
        },
        {
          title: this.$t('是否常用'),
          dataIndex: 'isCommon',
          scopedSlots: {customRender: 'isCommon'},
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    };
  },
  filters: {
  },
  created () {
    this.getCityTree();
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    getCityTree() {
      cityListTree().then(response => {
        this.cityList = response.data
      })
    },
    /** 查询银行支行列表 */
    getList () {
      this.loading = true
      pageBank(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        bankCode: undefined,
        cityCode: undefined,
        cityName: undefined,
        haveBankIcon: undefined,
        provinceCode: undefined,
        provinceName: undefined,
        sortOrder: "asc",
        pageNum: 1,
        pageSize: 10
      };
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    onCityChange() {
      this.queryParam.cityCode=this.citySelected[1]
    },


    onCommonChange(checked, record) {
      let data = {id:record.id, isCommon: checked}
      commonBank(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'),
            3
          );
          this.$emit('ok')
          record.isCommon=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },


    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delBranch(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/merchant/branch/export', {
            ...that.queryParam
          }, `银行支行_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
